import React from "react";
import { Link } from "react-router-dom";

/* ── Large atmospheric header icons (white, decorative) ── */
const PlaneHeaderIcon = () => (
  <svg width="96" height="96" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
  </svg>
);
const HeartHeaderIcon = () => (
  <svg width="96" height="96" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
  </svg>
);
const BankHeaderIcon = () => (
  <svg width="96" height="96" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 21h18M3 7v1a3 3 0 006 0V7m0 1a3 3 0 006 0V7m0 1a3 3 0 006 0V7M3 7l2.5-4h13L21 7M12 21V11M7 21V11M17 21V11" />
  </svg>
);
const ScalesHeaderIcon = () => (
  <svg width="96" height="96" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 3v18M3 6l4 8H3l4-8zM17 6l4 8h-4l4-8zM3 21h18M8 3h8" />
  </svg>
);

/* ── Small badge icons (inside coloured circle, bottom-left of header) ── */
const PlaneBadge = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
  </svg>
);
const HeartBadge = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
  </svg>
);
const BankBadge = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 21h18M3 7v1a3 3 0 006 0V7m0 1a3 3 0 006 0V7m0 1a3 3 0 006 0V7M3 7l2.5-4h13L21 7M12 21V11" />
  </svg>
);
const ScalesBadge = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 3v18M3 6l4 8H3l4-8zM17 6l4 8h-4l4-8zM3 21h18M8 3h8" />
  </svg>
);

const VERTICALS = [
  {
    id: "travel",
    title: "Travel & Hospitality",
    href: "/travel-hospitality",
    color: "#1a3a6b",
    iconBg: "#dbeafe",
    HeaderIcon: PlaneHeaderIcon,
    BadgeIcon: PlaneBadge,
    legacyItems: [
      "Airline Reservation & DCS Solutions",
      "Central Reservation Systems (CRS)",
      "Tour Operator & Travel ERP",
      "Hotel Management Systems",
      "Loyalty, CRM & Marketing Automation",
      "Online Booking Engines & Portals",
      "API Integration & Channel Management",
    ],
    aiItems: [
      "Demand forecasting & dynamic pricing",
      "Personalized itinerary recommendations",
      "Conversational booking & virtual agents",
      "Fraud detection & payment risk analytics",
      "Revenue optimization engines",
    ],
  },
  {
    id: "healthcare",
    title: "Healthcare",
    href: "/healthcare",
    color: "#166534",
    iconBg: "#dcfce7",
    HeaderIcon: HeartHeaderIcon,
    BadgeIcon: HeartBadge,
    legacyItems: [
      "Hospital Information Systems (HIS)",
      "Electronic Medical Records (EMR)",
      "Pharmacy & Laboratory Systems",
      "Revenue Cycle Management",
      "Telehealth & Patient Portals",
      "Appointment & Scheduling Systems",
      "Healthcare Data Exchange (HL7/FHIR)",
    ],
    aiItems: [
      "Clinical decision support systems",
      "Medical image analytics & diagnostics",
      "Patient risk & outcome prediction",
      "NLP for unstructured clinical notes",
      "Readmission prediction & care planning",
    ],
  },
  {
    id: "fintech",
    title: "Fintech / Insurance",
    href: "/insurance",
    color: "#92400e",
    iconBg: "#fef3c7",
    HeaderIcon: BankHeaderIcon,
    BadgeIcon: BankBadge,
    legacyItems: [
      "Core Banking & Loan Origination",
      "Policy Administration Systems",
      "Claims Management Platforms",
      "Enterprise Data Exchange (EDI/API)",
      "Compliance & Risk Management",
      "Business Rules Engine (BRMS)",
      "Financial Services Portals",
    ],
    aiItems: [
      "Credit scoring & underwriting AI",
      "Automated claims adjudication",
      "Anomaly & fraud detection",
      "Customer behavior & churn analytics",
      "AML intelligence & regulatory AI",
    ],
  },
  {
    id: "legal",
    title: "Legal",
    href: "/legal",
    color: "#6d28d9",
    iconBg: "#ede9fe",
    HeaderIcon: ScalesHeaderIcon,
    BadgeIcon: ScalesBadge,
    legacyItems: [
      "Case & Practice Management",
      "Document Management Systems",
      "E-Discovery & Workflow Automation",
      "Contract Lifecycle Management",
      "Legal Research Platforms",
      "Matter Billing & Time Tracking",
      "Legal Content Management Systems",
    ],
    aiItems: [
      "Legal research & case summarization",
      "Contract analysis & clause extraction",
      "Litigation outcome analytics",
      "Intelligent document classification",
      "Deadline intelligence & docketing",
    ],
  },
];

const NewIndustryVerticals = () => (
  <section className="verticals-v2" aria-labelledby="verticals-heading" id="industry-verticals">
    <div className="container">
      <p className="section-eyebrow">Our Industry Verticals</p>
      <h2 id="verticals-heading" className="section-title">
        Domain knowledge built over 30 years, now AI-enabled.
      </h2>
      <p className="section-sub">
        Proven execution capabilities across Travel, Healthcare, Insurance, Fintech and Legal —
        with AI as the intelligence layer on top of your existing enterprise systems.
        We understand Central Reservation Systems, Policy Administration, EMR, and Case Management
        not from the outside, but from decades of building and maintaining them.
      </p>

      <div className="row">
        {VERTICALS.map((v) => (
          <div key={v.id} className="col-lg-3 col-md-6 mb-4">
            <article className="vertical-card" aria-label={`${v.title} enterprise software solutions`}>

              {/* ── Card header: gradient background + atmospheric icon ── */}
              <div className={`vertical-card-header vertical-card-header--${v.id}`}>
                {/* Large atmospheric icon in background */}
                <div className="vertical-card-header-bg-icon" aria-hidden="true">
                  <v.HeaderIcon />
                </div>
                {/* Bottom gradient overlay */}
                <div className="vertical-card-header-overlay" aria-hidden="true" />
                {/* Small badge icon: bottom-left */}
                <div
                  className="vertical-card-badge-icon"
                  style={{ background: v.iconBg, color: v.color }}
                  aria-hidden="true"
                >
                  <v.BadgeIcon />
                </div>
              </div>

              {/* ── Card body ── */}
              <div className="vertical-card-body">
                <h3 className="vertical-card-title" style={{ color: v.color }}>
                  {v.title}
                </h3>
                <span className="vertical-card-badge">Legacy Expertise (30+ Years)</span>

                <ul className="vertical-card-list" aria-label={`Legacy ${v.title} systems`}>
                  {v.legacyItems.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>

                <p className="vertical-ai-label">AI-Enabled Capabilities</p>
                <ul className="vertical-ai-list" aria-label={`AI capabilities for ${v.title}`}>
                  {v.aiItems.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>

                <Link
                  to={v.href}
                  className="vertical-card-link"
                  style={{ color: v.color }}
                  aria-label={`Explore ${v.title} solutions`}
                >
                  Explore {v.title} →
                </Link>
              </div>
            </article>
          </div>
        ))}
      </div>

      <p className="text-center mt-2" style={{ fontSize: "12px", color: "#6b7280" }}>
        <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          style={{ marginRight: "6px", verticalAlign: "middle", color: "#22c55e" }}
          aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Proven execution across industry verticals. Trusted by 200+ global clients in 70+ countries since 1992.
      </p>
    </div>
  </section>
);

export default NewIndustryVerticals;
